import { jsxs, jsx } from 'react/jsx-runtime';
import { Flex, themedColor, font, Box, useViewportSize, useElementScrollState } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES, Button } from '@lemonade-hq/nuis';
import { rgba } from 'polished';
import styled from 'styled-components';
import { useCommonI18nContext } from '../../providers/I18nProvider.esm.js';
import { useNavContext } from '../../providers/NavProvider.esm.js';
import { View } from './types.esm.js';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  flex-direction: column;\n  height: 100%;\n  padding: 32px;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  ",
        ";\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n        height: 120px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  overflow-y: scroll;\n  height: 220px;\n  width: calc(100% + 26px);\n  padding: 8px 24px 20px 0;\n\n  /* Foreground, Background */\n  scrollbar-color: ",
        " ",
        ";\n  scrollbar-width: thin;\n  &::-webkit-scrollbar {\n    width: ",
        "px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ",
        ";\n    height: 10px;\n  }\n  &::-webkit-scrollbar-track {\n    background: ",
        ";\n  }\n\n  > p {\n    padding-right: ",
        "px;\n    color: ",
        ";\n    ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  right: ",
        "px;\n  top: 0;\n  height: 30px;\n  transform: translateY(-100%);\n  pointer-events: none;\n  background: linear-gradient(\n    to bottom,\n    ",
        " 0%,\n    ",
        " 50%,\n    ",
        "\n  );\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0;\n  right: ",
        "px;\n  bottom: 0;\n  height: 30px;\n  transform: translateY(100%);\n  pointer-events: none;\n  background: linear-gradient(\n    to top,\n    ",
        " 0%,\n    ",
        " 50%,\n    ",
        "\n  );\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  flex: 1 0 40%;\n  color: ",
        ";\n  background: ",
        ";\n  border: none;\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  position: relative;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  gap: 12px;\n  flex-direction: column;\n  position: relative;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  text-transform: uppercase;\n  text-align: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding-top: 12px;\n\n  > a {\n    text-decoration: underline;\n    color: ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
var INFO_WIDTH = 310;
var INFO_MAX_HEIGHT_CCPA = 300;
var SCROLL_GUTTER = 5;
var OVERLAY_OPACITY_START = 0.1;
var TITLE_ID = "cookie-consent-title";
var DESCRIPTION_ID = "cookie-consent-description";
var CookieConsentInformationWrapper = styled(Flex)(_templateObject());
var HeadingRow = styled(Flex)(_templateObject1(), themedColor("white"), font("main", {
    fontSize: "1.4rem",
    lineHeight: "2rem"
}));
var TextOverflow = styled(Box)(_templateObject3(), themedColor("nightRider"), themedColor("night"), SCROLL_GUTTER, themedColor("nightRider"), themedColor("night"), SCROLL_GUTTER, themedColor("white"), font("main", {
    fontSize: "1.4rem",
    lineHeight: "2rem"
}), MEDIA_QUERIES.tabletAndDesktop(_templateObject2()));
var Overlay = styled(Box)(_templateObject4(), SCROLL_GUTTER, function(param) {
    var theme = param.theme;
    return rgba(theme.colors.night, OVERLAY_OPACITY_START);
}, function(param) {
    var theme = param.theme;
    return rgba(theme.colors.night, 0.5);
}, themedColor("night"));
var TopOverlay = styled(Box)(_templateObject5(), SCROLL_GUTTER, function(param) {
    var theme = param.theme;
    return rgba(theme.colors.night, OVERLAY_OPACITY_START);
}, function(param) {
    var theme = param.theme;
    return rgba(theme.colors.night, 0.5);
}, themedColor("night"));
var RejectCustomizeButtonCCPA = styled(Button).attrs({
    size: "tiny"
})(_templateObject6(), themedColor("white"), themedColor("boulder"), themedColor("darkGray"));
var ButtonsWrapper = styled(Flex)(_templateObject7());
var ButtonWrapperCCPA = styled(Flex)(_templateObject8());
var Title = styled.h3(_templateObject9(), font("main", {
    fontSize: "1.6rem",
    lineHeight: "1.9rem",
    fontWeight: 700
}));
var CookiePolicyLink = styled(Flex)(_templateObject10(), themedColor("metal"), font("main", {
    fontSize: "1.4rem"
}));
var Information = function(param) {
    var onAccept = param.onAccept, onCustomize = param.onCustomize, currentView = param.currentView, isClosed = param.isClosed, onReject = param.onReject;
    var nav = useNavContext().nav;
    var t = useCommonI18nContext().t;
    var width = useViewportSize().width;
    var privacyPolicyUrl = "".concat(nav.privacy_policy, "#cookies");
    var _useElementScrollState = useElementScrollState(), ref = _useElementScrollState.ref, isScrolling = _useElementScrollState.isScrolling, hasReachedScrollEnd = _useElementScrollState.hasReachedScrollEnd;
    var inView = !isClosed && currentView === View.Information;
    var tabIndex = inView ? undefined : -1;
    return /*#__PURE__*/ jsxs(CookieConsentInformationWrapper, {
        "aria-current": inView ? "step" : undefined,
        "aria-hidden": inView ? undefined : true,
        width: [
            width,
            INFO_WIDTH
        ],
        children: [
            /*#__PURE__*/ jsxs(HeadingRow, {
                children: [
                    /*#__PURE__*/ jsx(Title, {
                        id: TITLE_ID,
                        children: t("cookie_consent.information.title")
                    }),
                    isScrolling && /*#__PURE__*/ jsx(TopOverlay, {})
                ]
            }),
            /*#__PURE__*/ jsx(TextOverflow, {
                ref: ref,
                children: /*#__PURE__*/ jsx("p", {
                    "data-testid": DESCRIPTION_ID,
                    id: DESCRIPTION_ID,
                    children: t("cookie_consent.information.description")
                })
            }),
            /*#__PURE__*/ jsxs(ButtonWrapperCCPA, {
                children: [
                    !hasReachedScrollEnd && /*#__PURE__*/ jsx(Overlay, {}),
                    /*#__PURE__*/ jsx(Button, {
                        flavor: "primary",
                        onClick: function() {
                            return onAccept({
                                isAcceptAll: true
                            });
                        },
                        size: "tiny",
                        tabIndex: tabIndex,
                        children: t("cookie_consent.information.accept_btn_title")
                    }),
                    /*#__PURE__*/ jsxs(ButtonsWrapper, {
                        children: [
                            /*#__PURE__*/ jsx(RejectCustomizeButtonCCPA, {
                                onClick: onReject,
                                tabIndex: tabIndex,
                                children: t("cookie_consent.information.reject_btn_title")
                            }),
                            /*#__PURE__*/ jsx(RejectCustomizeButtonCCPA, {
                                onClick: onCustomize,
                                tabIndex: tabIndex,
                                children: t("cookie_consent.information.customize_btn_title")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ jsx(CookiePolicyLink, {
                children: /*#__PURE__*/ jsx("a", {
                    href: privacyPolicyUrl,
                    rel: "noopener noreferrer",
                    tabIndex: tabIndex,
                    target: "_blank",
                    children: t("cookie_consent.information.cookies_policy_link_text")
                })
            })
        ]
    });
};

export { DESCRIPTION_ID, INFO_MAX_HEIGHT_CCPA, INFO_WIDTH, Information, TITLE_ID };
